export class BranchModel {
    BranchNumber: number;
    BranchName: string;
    BranchNameShort: string;
    BranchNameAbbreviated: string;
    ShowStock: boolean;
    OrderEmail: string;
}
